import { Check, CheckCheck, FileIcon, Download, Trash2 } from "lucide-react";
import { useState } from "react";
import { deleteMessageApi, FILE_BASE_URL } from "../../app/api";
import toast from "react-hot-toast";
 
export default function MessageBubble({ message, onDelete }) {
  const [showMenu, setShowMenu] = useState(false);
  const isMe = message.sender === "me";
 
  let dateObj;
  const rawDate = message.created_at || message.createdAt || Date.now();
  if (typeof rawDate === 'string' && !rawDate.includes('Z')) {
    dateObj = new Date(rawDate.replace(' ', 'T') + 'Z');
  } else {
    dateObj = new Date(rawDate);
  }
  const timeString = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
 
  if (message.type === "call_log") {
    return (
      <div className="flex justify-center my-3">
        <div className="bg-white/5 border border-white/10 rounded-full px-4 py-1 flex items-center gap-2 shadow-sm">
          <span className="text-[11px] text-white/60 font-medium tracking-wide">{message.text}</span>
          <span className="text-[9px] text-white/30 font-bold uppercase tracking-tighter">{timeString}</span>
        </div>
      </div>
    );
  }
 
 
  const handleDelete = async () => {
    try {
      const res = await deleteMessageApi(message.id);
      if (res.success) {
        toast.success("Message deleted");
        if (onDelete) onDelete(message.id);
      }
    } catch (err) {
      toast.error("Failed to delete message");
    }
    setShowMenu(false);
  };
 
  const renderText = (text) => {
    if (!text) return "";
    // Regex to match @Name or @Name Name
    const parts = text.split(/(@[a-zA-Z]+\s?[a-zA-Z]*)/g);
    return parts.map((part, i) => {
      if (part.startsWith("@")) {
        return (
          <span key={i} className="text-yellow-300 font-bold bg-yellow-500/10 px-1 rounded">
            {part}
          </span>
        );
      }
      return part;
    });
  };
 
  return (
    <div className={`flex ${isMe ? "justify-end" : "justify-start"} mb-1`}>
      <div
        className={`flex flex-col relative px-3 py-1.5 rounded-2xl text-[13px] max-w-[80%] group ${isMe ? "bg-indigo-600 text-white rounded-tr-none shadow-lg shadow-indigo-500/10" : "bg-[#1f2228] text-white/90 rounded-tl-none border border-white/5"}`}
        onContextMenu={(e) => {
          if (isMe && !message.is_deleted) {
            e.preventDefault();
            setShowMenu(true);
          }
        }}
      >
        {message.is_deleted ? (
          <span className="italic opacity-50 text-[11px]">
            {isMe ? "You deleted this message" : "This message was deleted"}
          </span>
        ) : message.type === "image" ? (
          <div className="rounded-lg overflow-hidden my-1">
            <img
              src={message.text.startsWith('http') ? message.text : `${FILE_BASE_URL}/${message.text.startsWith('/') ? message.text.slice(1) : message.text}`}
              alt="Chat Content"
              className="max-w-full h-auto cursor-pointer hover:opacity-90 transition-opacity"
              onClick={() => window.open(message.text.startsWith('http') ? message.text : `${FILE_BASE_URL}/${message.text.startsWith('/') ? message.text.slice(1) : message.text}`, '_blank')}
            />
          </div>
        ) : message.type === "file" ? (
          <a
            href={message.text.startsWith('http') ? message.text : `${FILE_BASE_URL}/${message.text.startsWith('/') ? message.text.slice(1) : message.text}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-black/20 p-2 rounded-lg hover:bg-black/30 transition-colors my-1"
          >
            <div className="p-2 bg-indigo-500/20 rounded-md">
              <FileIcon size={20} className="text-indigo-400" />
            </div>
            <div className="flex-1 overflow-hidden">
              <p className="text-[12px] font-medium truncate">
                {message.text.split('/').pop()}
              </p>
              <p className="text-[10px] text-white/40">Click to download</p>
            </div>
            <Download size={16} className="text-white/40" />
          </a>
        ) : (
          <span>{renderText(message.text)}</span>
        )}
 
        {showMenu && (
          <div className="absolute top-0 right-0 mt-8 mr-2 z-50 bg-[#12141c] border border-white/10 rounded-xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200 min-w-[120px]">
            <button
              onClick={handleDelete}
              className="w-full text-left px-4 py-2.5 text-[11px] font-bold text-red-400 hover:bg-red-500/10 flex items-center justify-between group/btn"
              type="button"
            >
              DELETE
              <Trash2 size={14} className="group-hover/btn:scale-110 transition-transform" />
            </button>
            <button
              onClick={() => setShowMenu(false)}
              className="w-full text-left px-4 py-1.5 text-[9px] text-white/20 hover:text-white/40 text-center uppercase font-black"
              type="button"
            >
              Cancel
            </button>
          </div>
        )}
       
        <div className="flex justify-end items-center gap-1 mt-1 opacity-40">
          <span className="text-[9px] font-bold">{timeString}</span>
          {isMe && !message.group_id && !message.groupId && (
            message.is_seen ? <CheckCheck size={10} className="text-blue-400" /> : <Check size={10} />
          )}
        </div>
      </div>
    </div>
  );
}




// import { Check, CheckCheck, FileIcon, Download, Trash2 } from "lucide-react";
// import { useState } from "react";
// import { deleteMessageApi } from "../../app/api";
// import toast from "react-hot-toast";

// export default function MessageBubble({ message, onDelete }) {
//   const [showMenu, setShowMenu] = useState(false);
//   const isMe = message.sender === "me";

//   let dateObj;
//   const rawDate = message.created_at || message.createdAt || Date.now();
//   if (typeof rawDate === 'string' && !rawDate.includes('Z')) {
//     dateObj = new Date(rawDate.replace(' ', 'T') + 'Z');
//   } else {
//     dateObj = new Date(rawDate);
//   }
//   const timeString = dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

//   if (message.type === "call_log") {
//     return (
//       <div className="flex justify-center my-3">
//         <div className="bg-white/5 border border-white/10 rounded-full px-4 py-1 flex items-center gap-2 shadow-sm">
//           <span className="text-[11px] text-white/60 font-medium tracking-wide">{message.text}</span>
//           <span className="text-[9px] text-white/30 font-bold uppercase tracking-tighter">{timeString}</span>
//         </div>
//       </div>
//     );
//   }


//   const handleDelete = async () => {
//     try {
//       const res = await deleteMessageApi(message.id);
//       if (res.success) {
//         toast.success("Message deleted");
//         if (onDelete) onDelete(message.id);
//       }
//     } catch (err) {
//       toast.error("Failed to delete message");
//     }
//     setShowMenu(false);
//   };

//   const renderText = (text) => {
//     if (!text) return "";
//     // Regex to match @Name or @Name Name
//     const parts = text.split(/(@[a-zA-Z]+\s?[a-zA-Z]*)/g);
//     return parts.map((part, i) => {
//       if (part.startsWith("@")) {
//         return (
//           <span key={i} className="text-yellow-300 font-bold bg-yellow-500/10 px-1 rounded">
//             {part}
//           </span>
//         );
//       }
//       return part;
//     });
//   };

//   return (
//     <div className={`flex ${isMe ? "justify-end" : "justify-start"} mb-1`}>
//       <div
//         className={`flex flex-col relative px-3 py-1.5 rounded-2xl text-[13px] max-w-[80%] group ${isMe ? "bg-indigo-600 text-white rounded-tr-none shadow-lg shadow-indigo-500/10" : "bg-[#1f2228] text-white/90 rounded-tl-none border border-white/5"}`}
//         onContextMenu={(e) => {
//           if (isMe && !message.is_deleted) {
//             e.preventDefault();
//             setShowMenu(true);
//           }
//         }}
//       >
//         {message.is_deleted ? (
//           <span className="italic opacity-50 text-[11px]">
//             {isMe ? "You deleted this message" : "This message was deleted"}
//           </span>
//         ) : message.type === "image" ? (
//           <div className="rounded-lg overflow-hidden my-1">
//             <img 
//               src={message.text.startsWith('http') ? message.text : `/${message.text.startsWith('/') ? message.text.slice(1) : message.text}`} 
//               alt="Content" 
//               className="max-w-full h-auto cursor-pointer hover:opacity-90 transition-opacity"
//               onClick={() => window.open(message.text.startsWith('http') ? message.text : `/${message.text.startsWith('/') ? message.text.slice(1) : message.text}`, '_blank')}
//             />
//           </div>
//         ) : message.type === "file" ? (
//           <a 
//             href={message.text.startsWith('http') ? message.text : `/${message.text.startsWith('/') ? message.text.slice(1) : message.text}`}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="flex items-center gap-2 bg-black/20 p-2 rounded-lg hover:bg-black/30 transition-colors my-1"
//           >
//             <div className="p-2 bg-indigo-500/20 rounded-md">
//               <FileIcon size={20} className="text-indigo-400" />
//             </div>
//             <div className="flex-1 overflow-hidden">
//               <p className="text-[12px] font-medium truncate">
//                 {message.text.split('/').pop()}
//               </p>
//               <p className="text-[10px] text-white/40">Click to download</p>
//             </div>
//             <Download size={16} className="text-white/40" />
//           </a>
//         ) : (
//           <span>{renderText(message.text)}</span>
//         )}

//         {showMenu && (
//           <div className="absolute top-0 right-0 mt-8 mr-2 z-50 bg-[#12141c] border border-white/10 rounded-xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200 min-w-[120px]">
//             <button
//               onClick={handleDelete}
//               className="w-full text-left px-4 py-2.5 text-[11px] font-bold text-red-400 hover:bg-red-500/10 flex items-center justify-between group/btn"
//               type="button"
//             >
//               DELETE
//               <Trash2 size={14} className="group-hover/btn:scale-110 transition-transform" />
//             </button>
//             <button
//               onClick={() => setShowMenu(false)}
//               className="w-full text-left px-4 py-1.5 text-[9px] text-white/20 hover:text-white/40 text-center uppercase font-black"
//               type="button"
//             >
//               Cancel
//             </button>
//           </div>
//         )}
        
//         <div className="flex justify-end items-center gap-1 mt-1 opacity-40">
//           <span className="text-[9px] font-bold">{timeString}</span>
//           {isMe && !message.group_id && !message.groupId && (
//             message.is_seen ? <CheckCheck size={10} className="text-blue-400" /> : <Check size={10} />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }